
function createFunctionName(function_name) {
    return function_name.replace(/\_/g, "/");
}

export default createFunctionName;
